import { IDonor } from '@nkr/models/index';
import { Panel, OverlayTrigger, Glyphicon, Label } from 'react-bootstrap';
import { TableWrapper } from './styles';
import PopoverTemplate from '@nkr/components/popover-template';

interface IProps {
    donor: IDonor,
}

const DonorAnatomy = (props: IProps) => {
    const { donor } = props;

    return (
        <Panel>
            <Panel.Heading>
                <span className='heading medium'>Donor Anatomy</span>
                <OverlayTrigger trigger='click' placement='top' rootClose overlay={
                    <PopoverTemplate>
                        The final post-procurement anatomy of the donor kidney as it will be received and implanted by the recipient center.
                    </PopoverTemplate>
                }>
                    <Glyphicon glyph='info-sign' style={{ marginLeft: 6, cursor: 'pointer' }} />
                </OverlayTrigger>
            </Panel.Heading>
            <Panel.Body>
                <TableWrapper striped condensed>
                    <tbody>
                        <tr>
                            <td>Which Kidney?</td>
                            <td><Label>{donor.whichKidneyDescription}</Label></td>
                        </tr>
                        <tr>
                            <td colSpan={2} style={{ padding: 0 }}>
                                <div style={{ border: '1px solid #ddd', borderRadius: 4, margin: '4px 6px' }}>
                                    <div style={{ padding: '4px 8px', fontWeight: 'bold', borderBottom: '1px solid #ddd', backgroundColor: '#f5f5f5', textAlign: 'left' }}>
                                        Functional Anatomy
                                    </div>
                                    <TableWrapper striped condensed style={{ marginBottom: 0 }}>
                                        <tbody>
                                            <tr>
                                                <td>Number of Arteries</td>
                                                <td><Label>{donor.numberOfArteries != null && donor.numberOfArteries >= 0 ? donor.numberOfArteries : '?'}</Label></td>
                                            </tr>
                                            <tr>
                                                <td>Number of Veins</td>
                                                <td><Label>{donor.numberOfVeins != null && donor.numberOfVeins >= 0 ? donor.numberOfVeins : '?'}</Label></td>
                                            </tr>
                                            <tr>
                                                <td>Number of Ureters</td>
                                                <td><Label>{donor.numberOfUreters != null && donor.numberOfUreters >= 0 ? donor.numberOfUreters : '?'}</Label></td>
                                            </tr>
                                        </tbody>
                                    </TableWrapper>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td>Has Nutcracker Syndrome</td>
                            <td><Label>{donor.hasNutcracker == 1 ? 'Yes' : (donor.hasNutcracker == 0 ? 'No' : '?')}</Label></td>
                        </tr>
                        <tr>
                            <td>Has Early Bifurcation</td>
                            <td><Label>{donor.hasEarlyBifurcation ? (donor.earlyBifurcationLength + 'mm') : 'No'}</Label></td>
                        </tr>
                        <tr>
                            <td>Kidney CT/US Height (cm)</td>
                            <td><Label>{donor.kidneyHeight}</Label></td>
                        </tr>
                        <tr>
                            <td>Kidney CT/US Length (cm)</td>
                            <td><Label>{donor.kidneyLength}</Label></td>
                        </tr>
                        <tr>
                            <td>Kidney CT/US Width (cm)</td>
                            <td><Label>{donor.kidneyWidth}</Label></td>
                        </tr>
                        <tr>
                            <td>Kidney 3D-CT Volume (cc)</td>
                            <td><Label>{donor.kidneyVolume}</Label></td>
                        </tr>
                    </tbody>
                </TableWrapper>
            </Panel.Body>
        </Panel>
    );
};

export default DonorAnatomy;
